// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import PipDaysToExpiryWidget from '../../shared/components/pip-days-to-expiry-widget';
import PipDetailedInformation from './pip-detailed-information';
import PipDetails from '@deere/cps-it.warranty-model-factory/lib/pip-details';

const PipDetailsPanel = props =>
    <section className='pip-details-panel'>
        <header>
            <h2>
                <FormattedMessage id='PIP_DETAILS'/>
            </h2>
            {props.pipDetails.daysLeft > -1 &&
                <PipDaysToExpiryWidget
                    daysLeft={props.pipDetails.daysLeft}
                    metric={props.pipDetails.metric.key}
                    pipCompletionStatus=''
                    showIndicatorOnly={false}
                />
            }
        </header>
        <PipDetailedInformation pipDetails={props.pipDetails}/>
    </section>;

PipDetailsPanel.displayName = 'PipDetailsHeader';
PipDetailsPanel.propTypes = {
    pipDetails: PropTypes.instanceOf(PipDetails).isRequired
};

export default PipDetailsPanel;



// WEBPACK FOOTER //
// ./src/pip/pip-details/components/pip-details-panel.js